import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import FallWithInjuryComponentsStep1Part1 from "./fall-with-injury-components-step1-parts/fall-with-injury-components-step1-part1";

export default class FallWithInjuryComponentsStep1Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: FallWithInjuryComponentsStep1ComponentMainConfig) {
		let context = this;
		context._parts.push(new FallWithInjuryComponentsStep1Part1(context.config.scenario, () => {
			config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface FallWithInjuryComponentsStep1ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: FallWithInjuryComponentsStep1ComponentPart1Config;
	onDone: () => void;
}

export interface FallWithInjuryComponentsStep1ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}